import type { FaireProductEntity } from "../../entity_types/product";

export const p_r3ehduzjzv: FaireProductEntity = {
  token: "p_r3ehduzjzv",
  type: "product",
  name: "Bunny -Organic Baby Lovey Security Knit Blanket Cuddle Cloth",
  brandToken: "b_7fghelgl",
  brandName: "Viverano Organics",
  imageUrl:
    "https://cdn.faire.com/fastly/2809424d79f9a0bd0fbddffd41037c5d1c9d85745b212d7183efadc68ad714c7.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/fae307e9f4ad7591d678f83301f9cd691dec484dd1e3fdb53d988db4d1ebf820.jpeg",
    "https://cdn.faire.com/fastly/a8320dee636bf5dbe9a5e4854e96551e60a4d8b4f36a3825d7af27d341c3e87b.jpeg",
    "https://cdn.faire.com/fastly/f762945830b4c0f6fe3c3605037156372ebff4e3d5ac422411dbb69665c4552d.jpeg",
    "https://cdn.faire.com/fastly/31507d0e88a2803ac1cc1cd0e7570c49c725d9d7f151c9d8c357c1a58c6dbf9f.jpeg",
    "https://cdn.faire.com/fastly/69b920a85adf18f61d0112336ff84f737229593d954d79e2259d9b4773e4cd50.jpeg",
    "https://cdn.faire.com/fastly/5f529a172cd267717a6fe550d6159e5b7e9d98af87b23ef46c9346f75b1cd905.png",
    "https://cdn.faire.com/fastly/81e33161210b7dc7e8d9eee24b972a72d891ddba3746d28aa37e01d06daa62f6.png",
    "https://cdn.faire.com/fastly/340992587cc715cafaa795d118400585b883ec6f5064e356b36d2558affe3a17.jpeg",
    "https://cdn.faire.com/fastly/84415c4cf6b3ffadbd0373abd3f2ede88a779416b6bc16183063e7eab4c3a7ff.jpeg",
    "https://cdn.faire.com/fastly/7de42f55a31f6976be34a58d66f652c5c3471c59d6052f7de876bb188980368a.jpeg",
    "https://cdn.faire.com/fastly/00ad1ed8c924ced05081f7a78e04c79ef7e622fe1fab7db2e87d788c35bc693f.jpeg",
    "https://cdn.faire.com/fastly/781b640b0c2536819f181b4174b26d0bedd6a64c9902b0cb20a7e75118bb51bf.jpeg",
    "https://cdn.faire.com/fastly/73d5fec24c15da6874e9b79588ab063cae6df9ac9cf80af13a414e1941dc7f72.jpeg",
    "https://cdn.faire.com/fastly/e50cca14ebf7be714aed67ad193c4f72ebd135f957dbe315d5bc0b2e7e297e5c.jpeg",
    "https://cdn.faire.com/fastly/f1e0a3ab4c19de7cbb82aca16ce846b907201abf1e256852ef234e7798a2154c.jpeg",
    "https://cdn.faire.com/fastly/1d0a8b73535b1f47f555c3adef0e049873407871b827588e3585c96b77ba9f13.jpeg",
    "https://cdn.faire.com/fastly/dbfd1e86cca98668b0ac30b5b80bac7bc21aef2488a14961b3299e30852f2778.jpeg",
    "https://cdn.faire.com/fastly/8c8d41b7dfd815fc3746749d1f3823c7c297f746cac6892e2d7fb21061ab8030.jpeg",
    "https://cdn.faire.com/fastly/bbee39994c6cc50ab1844608ea78c80648461b462f650c4dbd4386494b5adf94.png",
  ],
  priceDollars: 16,
  description:
    "Luxurious 100% organic cotton soft sweater knit lovey security blanket toy for babies - 14x14\" approx.\n• Ultra-Soft, lightweight, all-season, breathable, cozy and comfy.\n• Non-toxic & natural fabrication for sensitive skin, eco-friendly & sustainable materials used.\n• Made from sustainably grown organic cotton, supporting better livelihoods of small grower farmers.\n• Conscientiously designed in USA & ethically made by artisans at a GOTS certified facility in India.\n• Experience 'pure comfort' by Viverano, a family-owned small business.\nWashing instructions: Machine wash cold. Tumble dry.\n\n𝐕𝐈𝐕𝐄𝐑𝐀𝐍𝐎 𝐎𝐫𝐠𝐚𝐧𝐢𝐜 𝐓𝐨𝐲𝐬:\n• Quirky & cuddly collection of organic cotton fine knit toys for your precious little ones.\n• Fresh & imaginative designs to bring joy and wonder to babies, kids and even adults.\n• Lovingly made by hand using certified organic cotton, safe for hugging & snuggling.\n• Great for buddy adventures, good company and bedtime snuggles.",
  tags: [],
  msrpDollars: 30,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-08-13T18:02:29.438Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
